import { Ionicons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { Stack, useRouter } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export default function PrivacyPolicyScreen() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <SafeAreaView style={styles.container} edges={["top"]}>
      <StatusBar style="dark" />
      <Stack.Screen options={{ headerShown: false }} />
      
      <LinearGradient
        colors={["#FBEFE3", "#FFFFFF"]}
        locations={[0, 0.35]}
        style={styles.gradient}
      >
        {/* Header */}
        <View style={styles.header}>
          <TouchableOpacity onPress={() => router.back()} style={styles.backButton}>
            <Ionicons name="chevron-back" size={24} color="#1C453F" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>{t("privacy.headerTitle")}</Text>
          <View style={{ width: 40 }} />
        </View>

        <ScrollView 
          contentContainerStyle={styles.content}
          showsVerticalScrollIndicator={false}
        >
          <Text style={styles.lastUpdate}>{t("privacy.lastUpdate")}</Text>

          <Section title={t("privacy.section1Title")}>
            <Text style={styles.text}>
              {t("privacy.section1Body")}
            </Text>
          </Section>

          <Section title={t("privacy.section2Title")}>
            <Text style={styles.text}>{t("privacy.section2Intro")}</Text>
            <BulletPoint text={t("privacy.section2Bullet1")} />
            <BulletPoint text={t("privacy.section2Bullet2")} />
            <BulletPoint text={t("privacy.section2Bullet3")} />
            <BulletPoint text={t("privacy.section2Bullet4")} />
          </Section>

          <Section title={t("privacy.section3Title")}>
            <Text style={styles.text}>{t("privacy.section3Intro")}</Text>
            <BulletPoint text={t("privacy.section3Bullet1")} />
            <BulletPoint text={t("privacy.section3Bullet2")} />
            <BulletPoint text={t("privacy.section3Bullet3")} />
            <Text style={styles.textBold}>
              {t("privacy.section3Emphasis")}
            </Text>
          </Section>

          <Section title={t("privacy.section4Title")}>
            <Text style={styles.text}>
              {t("privacy.section4Body")}
            </Text>
          </Section>

          <Section title={t("privacy.section5Title")}>
            <Text style={styles.text}>{t("privacy.section5Intro")}</Text>
            <BulletPoint text={t("privacy.section5Bullet1")} />
            <BulletPoint text={t("privacy.section5Bullet2")} />
            <BulletPoint text={t("privacy.section5Bullet3")} />
          </Section>

          <Section title={t("privacy.section6Title")}>
            <Text style={styles.text}>
              {t("privacy.section6Body")}
            </Text>
          </Section>

          <Section title={t("privacy.section7Title")}>
            <Text style={styles.text}>
              {t("privacy.section7Body")}
            </Text>
          </Section>

          <View style={{ height: 40 }} />
        </ScrollView>
      </LinearGradient>
    </SafeAreaView>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {children}
    </View>
  );
}

function BulletPoint({ text }: { text: string }) {
  return (
    <View style={styles.bulletRow}>
      <Text style={styles.bullet}>•</Text>
      <Text style={styles.bulletText}>{text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FBEFE3",
  },
  gradient: {
    flex: 1,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#FFF",
    alignItems: "center",
    justifyContent: "center",
  },
  headerTitle: {
    fontFamily: "Inter_700Bold",
    fontSize: 18,
    color: "#1C453F",
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 8,
  },
  lastUpdate: {
    fontFamily: "Inter_400Regular",
    fontSize: 12,
    color: "#999",
    marginBottom: 24,
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontFamily: "Inter_700Bold",
    fontSize: 16,
    color: "#1C453F",
    marginBottom: 8,
  },
  text: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#333",
    lineHeight: 22,
    marginBottom: 8,
  },
  textBold: {
    fontFamily: "Inter_600SemiBold",
    fontSize: 14,
    color: "#1C453F",
    lineHeight: 22,
    marginTop: 8,
  },
  bulletRow: {
    flexDirection: "row",
    paddingLeft: 8,
    marginBottom: 4,
  },
  bullet: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#CD7728",
    marginRight: 8,
  },
  bulletText: {
    fontFamily: "Inter_400Regular",
    fontSize: 14,
    color: "#333",
    flex: 1,
    lineHeight: 20,
  },
});
